import { PageType } from "../types/core";

export const PAGE = {
    MAP: 'map',
    LIVE: 'live',
    DISPATCH: 'dispatch',
    PLANNER: 'planner',
    CODISPATCH: 'co-dispatch',
    JOBS: 'jobs',
    PLACES: 'places',
    ZONES: 'zones',
    MEMBERS: 'members',
    TEAMS: 'teams',
    FORMS: 'forms',
    HELP: 'help',
    MESSAGES: 'messages',
    SETTINGS: 'settings',
    REPORTS: 'reports',
    ALERTS: 'alerts',
    TIMESHEET: 'timesheet',
    STATS: 'statistics',
    INTEGRATIONS: 'integrations',
    HEATMAP: 'heatmap',
    PHOTOS: "photos",
    LOCATION: 'location',
    REPLAYS: 'replays',
    ACTIVITYLOG: 'activitylog',
    FORMSUBMISSION: 'forms/submission',
    RESELLER: 'reseller',
    AFFILIATE: 'affiliate'
} as const;

export const LOCATION_PAGES: PageType[] = [PAGE.LIVE, PAGE.LOCATION, PAGE.REPLAYS, PAGE.HEATMAP];
export const DISPATCH_PAGES: PageType[] = [PAGE.DISPATCH, PAGE.PLANNER, PAGE.CODISPATCH, PAGE.JOBS];
export const ANALYZE_PAGES: PageType[] = [PAGE.STATS, PAGE.REPORTS, PAGE.TIMESHEET, PAGE.ACTIVITYLOG, PAGE.PHOTOS];
export const MANAGE_PAGES: PageType[] = [PAGE.MEMBERS, PAGE.TEAMS, PAGE.PLACES, PAGE.ZONES];
export const FORMS_PAGES: PageType[] = [PAGE.FORMS];
/** Pages that only come with a Dispatch plan; a location plan sees the upgrade page there. */
export const DISPATCH_PLAN_PAGES: PageType[] = [...DISPATCH_PAGES, PAGE.FORMS, PAGE.PHOTOS];
